import { CallPublicApi, handleJSONResponse } from './common';
import { OptInRequest } from '@services/opt-in/types/api/opt-in-request';
import { OptInResponse } from '@services/opt-in/types/api/opt-in-response';

const callAPI = CallPublicApi('opt-in');

export const check = async (
  artistId: string,
  feature: string
): Promise<{ optIn: boolean }> => {
  const response = await callAPI(`/${artistId}/${feature}`, 'GET');

  return handleJSONResponse(response);
};

export const checkContact = async (
  contact: string,
  feature: string
): Promise<{ optIn: boolean }> => {
  const response = await callAPI(`/contact`, 'POST', { contact, feature });

  return handleJSONResponse(response);
};

export const optIn = async (payload: OptInRequest): Promise<OptInResponse> => {
  const response = await callAPI(`/`, 'POST', payload);

  return handleJSONResponse(response);
};
